import React, { FunctionComponent, memo } from 'react'
import styles from './Participants.module.sass'
import UserPanel from '../../../../data-components/elements/UserElement/UserElement'
import { PERMISSIONS } from '../../../../../constants/permissions'
import clsx from 'clsx'
import Button from '../../../../controls/Button/Button'
import BellIcon from '../../../../../../files/subscription/subscribe.svg'
import BellOffIcon from '../../../../../../files/subscription/unsubscribe.svg'
import { useAllPermissions, useRootSelector } from '../../../../../utils/hooks'
import { User } from '../../../../../responses/users'
import { Department } from '../../../../../responses/departments'

export interface SubscribedUser extends User {
    subscribed: boolean,
    departments?: Department[],
}

interface Props {
    className?: string,
    user: SubscribedUser,
    onSubscribe: (user: SubscribedUser) => void,
    onUnsubscribe: (user: SubscribedUser) => void,
}

const Participant: FunctionComponent<Props> = props => {
    const currentUserId = useRootSelector(state => state.global.user.data?.id)
    const canUnsubscribe = useAllPermissions([PERMISSIONS.PROJECT.UNSUBSCRIBE])

    return <UserPanel
        className={clsx(props.className, styles.participant)}
        user={props.user}
    >
        {
            (canUnsubscribe || currentUserId == props.user.id) && <Button
                className={clsx(styles.subscription, { [styles.active]: !props.user.subscribed })}
                title={props.user.subscribed ? 'Отписать от уведомлений' : 'Подписать на уведомления'}
                onClick={() => (props.user.subscribed ? props.onUnsubscribe : props.onSubscribe)(props.user)}
            >
                {props.user.subscribed ? <BellIcon/> : <BellOffIcon/>}
            </Button>
        }
    </UserPanel>
}

export default memo(Participant)